import {QuestionComponent} from './QuestionComponent'
import {UntypedFormGroup, ValidatorFn} from '@angular/forms'
import {
  PriceRangeComponent
} from "../../modules/survey/survey-viewer/survey-question/types/price-range/price-range.component";
import {Matrix} from "./Matrix";

export class PriceRange extends Matrix {
  getDisplayComponent() {
    return new QuestionComponent(PriceRangeComponent, this)
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.rowKeys.forEach(rKey => {
      this.statementKeys.forEach(sKey => {
        surveyForm.get(this.key).get(rKey).get(this.commentsControlName).get(sKey).setValue(0, {emitEvent: false})
        surveyForm.get(this.key).get(rKey).get(this.formControlName).get(sKey).setValue(true, {emitEvent: false})
      })
    })
  }

  buildFormGroupValidators(): ValidatorFn[] {
    return [this.isPositiveFormValidator(this)]
  }

  isPositiveFormValidator(priceRange: PriceRange): ValidatorFn {
    return function validate(formGroup: UntypedFormGroup) {
      let notPositive = false
      const wrongValue = {}
      const control = formGroup.controls[Object.keys(formGroup.controls)?.[0]]?.get('comments')
      if (!control) return null
      const statementValues = control?.value
      const keys = Object.keys(statementValues || {})
      keys.forEach(sKey => {
        if (statementValues[sKey] === '') return
        const value = +statementValues[sKey]
        notPositive = notPositive || value === 0
        if (notPositive) return;

        switch (sKey) {
          case 'too_expensive':
            if (keys.some(k => +statementValues[k] > value)) {
              wrongValue['too_expensive'] = {value}
            }
            break
          case 'not_bargain':
            if (keys.some(k => k !== 'too_expensive' && +statementValues[k] > value)) {
              wrongValue['not_bargain'] = {value}
            }
            break
          case 'not_expensive':
            if (statementValues['too_cheap'] > value) {
              wrongValue['not_expensive'] = {value}
            }
            break;
        }
      })
      if (notPositive) return {notPositive}
      if (Object.keys(wrongValue).length) return wrongValue

      return null
    }

  }

}
